export function removeTimezoneFromDate(date: Date | undefined): Date {
  if (!date) {
    return date;
  }

  return new Date(new Date(date).toString().slice(0, 15));
}
